import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatSlideToggleChange } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActuatorService } from 'src/app/services/actuator/actuator.service';
import { CarService } from 'src/app/services/car/car.service';
import { EntityService } from 'src/app/services/entity/entity.service';
import { HeadquarterService } from 'src/app/services/headquarter/headquarter.service';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { AlertService, MessageSeverity } from 'src/app/shared/services/alert.service';

@Component({
  selector: 'app-car-form',
  templateUrl: './car-form.component.html',
  styleUrls: ['./car-form.component.css']
})
export class CarFormComponent implements OnInit {
  carForm: FormGroup;
  color: "";
  colorFont: "";
  gatewaySelect: number;
  headquarterSelect: number;
  enterpriseSelect: number;
  enabledRead: number;
  enabledWrite: number;
  edit = false;
  public id = 0;
  editHeadquarter = false;
  gateways = [];
  entities = [];
  headquarters = [];
  disabledHeadquarter = false;
  actuatorTypes = [];
  actuatorDataTypes = [];
  actuatorTypeSelect = 0;
  showEntity = false;
  actuatorDataTypeSelect = 0;
  selectorNoEntity = false;
  public new = false;
  entitySelect = 0;
  cars = [];
  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private actuatorService: ActuatorService,
    public dialog: MatDialog,
    private headquarterService: HeadquarterService,
    private spinner: NgxSpinnerService,
    public activatedRoute: ActivatedRoute,
    private carService: CarService,
    private entityService: EntityService,
    private router: Router,
  ) {
    var _this = this;
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        if(params.new == "true"){
          _this.new = true;
          document.getElementById("titleHeaderNav").innerHTML = 'Administración > <span class="font-weight-bold">Nuevo Vehículo</span>';
        }else{
          _this.id = params.id;
          _this.new = false;
          document.getElementById("titleHeaderNav").innerHTML = 'Administración > <span class="font-weight-bold">Editar Vehículo</span>';
        }
      });
    this.enterpriseSelect = (+localStorage.getItem(AppConstants.Session.ENTERPRISE));
  }


  ngOnInit() {
    this.createForm();
    this.getEntities();
    if(!this.new){
      this.edit = true;
      this.spinner.show();
      this.carService.get(this.id).subscribe((response) => {
        if(response.error == null){
          this.entitySelect = response.data.idEntity;
          if(this.entitySelect > 0){
            this.showEntity = true;
          }
          this.carForm.controls['licensePlate'].setValue(response.data.licensePlate);
          this.carForm.controls['model'].setValue(response.data.model);
          this.carForm.controls['brand'].setValue(response.data.brand);
          this.carForm.controls['year'].setValue(response.data.year);
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        this.headquarters = [];
        this.spinner.hide();
      });
    }
  }

  getEntities(){
        this.spinner.show();
        this.entityService.getListAll(this.enterpriseSelect).subscribe((response) => {
          this.entities = response.data;
          this.spinner.hide();
        },
          (error: HttpErrorResponse) => {
            this.spinner.hide();
          });
  }

  getActuatorDataTypes(){
    this.spinner.show();
    this.actuatorService.getListActuatorDataTypes().subscribe((response) => {
      this.actuatorDataTypes = response.data;
      this.spinner.hide();
    },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      });
}
/*
  setHeadquarter(){
    if(this.data.idHeadquarter > 0){
      var headquarters = JSON.parse(localStorage.getItem(AppConstants.Session.HEADQUARTERS));
      var _this = this;
      var items = headquarters.filter(x => x.idEnterprise == _this.data.idEnterprise);
      if(items.length > 0){
        _this.headquarters = items;
        if(_this.data.idHeadquarter != 0){
          _this.headquarterSelect = items[0].id;
          _this.disabledHeadquarter = true;
        }
      }
    }else{
      this.getHeadquarters();
    }
  }
*/

  getHeadquarters() {
    this.spinner.show();
    this.headquarterService.getListAll().subscribe((response) => {
      if(response.error == null){
        //this.headquarters = response.data.filter(f => f.idEnterprise == this.data.idEnterprise);
      }else{
        this.headquarters = [];
      }
    },
      (error: HttpErrorResponse) => {
        this.headquarters = [];
        this.spinner.hide();
      });
}

  createForm(){
    this.carForm = this.formBuilder.group({
      licensePlate: ['', [Validators.required,  Validators.maxLength(50)]],
      model: ['', []],
      brand: ['', []],
      year: ['', []],
      idEntity: ['', []],
    })
  }

  get f() { return this.carForm.controls; }

  save(){
    if(this.carForm.valid){
      const payload = {
        licensePlate:this.carForm.value["licensePlate"],
        model:this.carForm.value["model"],
        brand:this.carForm.value["brand"],
        year:this.carForm.value["year"],
        Id: this.new ? 0 : +this.id,
        idEnterprise: this.enterpriseSelect,
        idEntity: this.showEntity ? this.entitySelect : 0,
        idUser: localStorage.getItem(AppConstants.Session.USERID)
      }
     this.spinner.show();
     if(this.new){
        this.carService.create(payload).subscribe(_ => {
          if(!_.message){
            this.alertService.showMessage(AppConstants.TitleModal.CREATE_SENSOR, AppConstants.MessageModal.CREATE, MessageSeverity.success);
            this.spinner.hide();
          }else{
            this.alertService.showMessage(
              _.message,
              "",
              MessageSeverity.error);
              this.spinner.hide();
          }
        });
      }else{
        this.carService.update(payload).subscribe(_ => {
          if(!_.message){
            this.alertService.showMessage(AppConstants.TitleModal.UPDATE_SENSOR, AppConstants.MessageModal.UPDATE, MessageSeverity.success);
            this.spinner.hide();
          }else{
            this.alertService.showMessage(
              _.message,
              "",
              MessageSeverity.error);
            this.spinner.hide();
          }
        });
      }
    }else{
      this.carForm.markAllAsTouched();
    }
  }

  close() {
    this.dialog.closeAll();
  }

  changeGateway(data) {
    this.gatewaySelect = data.value;
  }

  changeEntity(data) {
    this.entitySelect = data.value;
  }

  changeHeadquarter(data) {
    this.headquarterSelect = data.value;
    //this.gateways = this.data.gateways.filter(x => x.idHeadquarter == data.value);
    if(this.gateways.length>0){
      this.gatewaySelect = this.gateways[0].id;
    }
  }

  changeActuatorDataType(data) {
    this.actuatorDataTypeSelect = data.value;
  }

  changeActuatorType(data) {
    this.actuatorTypeSelect = data.value;
    if(this.actuatorTypeSelect == 3){
      this.actuatorDataTypeSelect = 0;
    }
  }

  changeCarType(event: MatSlideToggleChange){
    this.showEntity = event.checked;
  }

  cancel(){
    this.router.navigate(['home/admin/car']);
  }
}
